'use client';

import React from 'react';
import { trackGAdsPhoneCallConversion } from '@/lib/analytics';

interface PhoneCallButtonProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  phone?: string;
}

export default function PhoneCallButton({
  children,
  className,
  style,
  phone = '587-990-7769',
}: PhoneCallButtonProps) {
  return (
    <a
      href={`tel:${phone}`}
      className={className}
      style={style}
      onClick={trackGAdsPhoneCallConversion}
    >
      {children}
    </a>
  );
}
